import { Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const TransactionHeader = () => (
  <div className="grid grid-cols-12 items-center mb-0 gap-4 px-2 py-1">
    <div className="col-span-2">
      <Text variant={TypographyStyles.EYEBROW}>Date</Text>
    </div>
    <div className="col-span-3">
      <Text variant={TypographyStyles.EYEBROW}>Description</Text>
    </div>
    <div className="col-span-2">
      <Text variant={TypographyStyles.EYEBROW}>Amount</Text>
    </div>
    <div className="col-span-2">
      <Text variant={TypographyStyles.EYEBROW}>Type</Text>
    </div>
    <div className="col-span-3">
      <Text variant={TypographyStyles.EYEBROW}>Category</Text>
    </div>
  </div>
)
